import { all, takeEvery, put, select, call } from 'redux-saga/effects';
import { FirebaseError } from 'firebase/app';

import { TRootState } from 'store';
import { authClient } from 'utils/capawesomeAuth';
import { captureException } from '@sentry/react';
import { ERROR_MESSAGES } from 'utils/constants';

import { SUBMIT_FORGOT_PASSWORD_FORM } from './actionTypes';
import { getEmail } from './selectors';
import { setLoading, setError, setSuccess } from './slice';

function* forgotPasswordSubmitSaga() {
  const state: TRootState = yield select();

  const email = getEmail(state);

  if (!email) {
    return;
  }

  yield put(setLoading(true));
  yield put(setError(''));

  try {
    yield call([authClient, authClient.sendPasswordResetEmail], { email });

    yield put(
      setSuccess(
        'Success! Password reset link sent to the provided email, if it exists in our database.'
      )
    );
  } catch (error: unknown) {
    let errorMessage = ERROR_MESSAGES.SOMETHING_WENT_WRONG;

    if (error instanceof FirebaseError) {
      switch (error.code) {
        case 'auth/user-not-found':
          // Don't reveal if user exists for security reasons
          yield put(
            setSuccess(
              'Success! Password reset link sent to the provided email, if it exists in our database.'
            )
          );
          return;
        case 'auth/invalid-email':
          errorMessage = 'Please enter a valid email address.';
          break;
        default:
          errorMessage = ERROR_MESSAGES.SOMETHING_WENT_WRONG;
          captureException(error);
      }
    } else {
      captureException(error);
    }

    yield put(setError(errorMessage));
  } finally {
    yield put(setLoading(false));
  }
}

export function* watchForgotPassword() {
  yield all([takeEvery(SUBMIT_FORGOT_PASSWORD_FORM, forgotPasswordSubmitSaga)]);
}
